/**
 * Shared CSS animation styles for Stresstimonials components
 * Used across StresstimonialsVideo, StresstimonialsCard variations
 */
export const STRESSTIMONIALS_MOBILE_ANIMATION_STYLES = `
  .mobile-card-animated {
    opacity: 0;
    transform: translateY(100px);
    transition: opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1),
                transform 0.8s cubic-bezier(0.16, 1, 0.3, 1);
  }

  .mobile-card-visible {
    opacity: 1;
    transform: translateY(0);
  }
`
